export type RuntimePageDataLookup<T> = { hit: true; value: T } | { hit: false };

export type RuntimePageDataSnapshot = Record<string, unknown>;

export type RuntimePageDataBridge = {
  read: (key: string) => RuntimePageDataLookup<unknown>;
  write: (key: string, value: unknown) => void;
};

declare global {
  var __SENDBOT_RUNTIME_PAGE_DATA_BRIDGE__: RuntimePageDataBridge | undefined;
}

const hydratedRuntimeData = new Map<string, unknown>();

export const installRuntimePageDataBridge = (
  bridge: RuntimePageDataBridge | undefined,
) => {
  globalThis.__SENDBOT_RUNTIME_PAGE_DATA_BRIDGE__ = bridge;
};

export const readRuntimePageData = <T>(
  key: string,
): RuntimePageDataLookup<T> => {
  if (hydratedRuntimeData.has(key)) {
    return { hit: true, value: hydratedRuntimeData.get(key) as T };
  }

  const serverLookup =
    globalThis.__SENDBOT_RUNTIME_PAGE_DATA_BRIDGE__?.read(key);
  if (serverLookup?.hit) {
    return { hit: true, value: serverLookup.value as T };
  }

  return { hit: false };
};

export const recordRuntimePageData = <T>(key: string, value: T): T => {
  globalThis.__SENDBOT_RUNTIME_PAGE_DATA_BRIDGE__?.write(key, value);
  return value;
};

export const hydrateRuntimePageData = (snapshot: unknown) => {
  hydratedRuntimeData.clear();

  if (
    typeof snapshot !== "object" ||
    snapshot === null ||
    Array.isArray(snapshot)
  ) {
    return;
  }

  for (const [key, value] of Object.entries(snapshot)) {
    hydratedRuntimeData.set(key, value);
  }
};

export const resetHydratedRuntimePageData = () => {
  hydratedRuntimeData.clear();
};
